const initProgressBarAnimation = player => {
  const controlBar = player.getChild('controlBar')
  const progressControlComp = controlBar.getChild('progressControl')
  const seekBarComp = progressControlComp.getChild('seekBar')
  const currentTimeComp = controlBar.getChild('currentTimeDisplay')

  const loadedBar = progressControlComp.$('.vjs-slider-bar')
  const sliderBar = progressControlComp.$('.vjs-slider')

  let mouseInfo = {
    mouseDown: false
  }

  sliderBar.addEventListener('mousedown', e => {
    handleMouseDown(e)
  })

  document.querySelector('body').addEventListener('mousemove', e => {
    updatePlayerTimeUI(e)
  })

  const handleMouseDown = e => {
    mouseInfo.mouseDown = true
    updatePlayerTimeUI(e)
    if (!progressControlComp.hasClass('active')) {
      progressControlComp.addClass('active')
    }
  }

  const updatePlayerTimeUI = e => {
    if (mouseInfo.mouseDown) {
      const playerTime = player.currentTime()
      seekBarComp.update(playerTime, seekBarComp.getPercent())
      progressControlComp.handleMouseMove(e)
      currentTimeComp.updateContent()
    }
  }

  document.querySelector('body').addEventListener('mouseup', () => {
    mouseInfo.mouseDown = false
    progressControlComp.removeClass('active')
  })

  const addModifierCircleToSliderBar = loadedBar => {
    const progressBall = document.createElement('div')
    progressBall.classList.add('vjs-progress-ball')
    loadedBar.appendChild(progressBall)
  }

  addModifierCircleToSliderBar(loadedBar)
}

export default initProgressBarAnimation
